<template>
    <nuxt-link v-if="logo" class="header-block" :to="mainPageUrl || {name: 'home'}">
        <img :src="$filters.srcHost(logo)" alt="" class="d-block header-logo py-1 py-md-3" :style="logoStyle" />
    </nuxt-link>
</template>

<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'

    @Component
    export class HeaderBlock extends Vue {
        get logo() {
            // TODO [P1] delete default logo file
            return cmsStore?.layoutSettings?.logo
        }

        get mainPageUrl() {
            return this.$conf.public.mainPageUrl
        }

        get logoStyle() {
            return /\.svg$/i.test(this.logo) ? {width: '100%'} : {width: 'auto'}
        }
    }

    export default HeaderBlock
</script>
